import get from 'lodash/get';
import pluralize from 'pluralize-ru';
import React from 'react';
import { withTranslation } from 'react-i18next';
import Slider from 'react-slick';
import i18next from 'i18next';
import { priceFormatter } from '../../../helpers/formatters';
import pluralizeEn from '../../../helpers/pluralizeEn';
import transliterate from '../../../helpers/transliterate';
import NumericInput from '../FormControls/NumericInput';
import CurrencyIcon from '../../../shared/components/Icons/Currency';
import Modal from '../Modal';
import { NextArrow, PrevArrow } from './Arrows';
import SliderStyled from './SliderStyled';
import Styled from './styled';
import Currency from '../../../shared/components/Currency';
import useCategoryModal from '../../../hooks/useCategoryModal';

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: <PrevArrow />,
  nextArrow: <NextArrow />,
};

/* eslint-disable react/no-unused-state */
// count in state needed for component rerender

const TRANSLATE_DESCRIPTION =
  'Выберите количество билетов. Система автоматически подберёт лучшие места в выбранных Вами зонах. При заказе более одного билета, места будут рядом.';

const CategoryModal = ({ t, i18n }) => {
  const { Widget } = window;
  const { category, hide, handleChange } = useCategoryModal();

  if (!category) return null;

  const renderImages = (images) => {
    if (Widget.isMobile) return null;
    if (!get(images, 'length')) return null;

    if (images.length === 1) {
      return (
        <Styled.Images>
          {images && images.map((image) => <Styled.Image key={image} src={image} height="240px" />)}
        </Styled.Images>
      );
    }

    return (
      <SliderStyled>
        <Slider {...settings}>
          {images.map((image: string) => (
            <Styled.Image key={image} src={image} height="240px" />
          ))}
        </Slider>
      </SliderStyled>
    );
  };

  const { id } = category;
  const value = get(Widget.categoriesController.selectedCategories[id], 'count', 0);

  const enSeatLabel = pluralizeEn(category.count, t('seat'), t('seats'));
  let countLabel;
  switch (i18n.language) {
    case 'en':
      countLabel = `${category.count} ${enSeatLabel}`;
      break;
    case 'ru':
    case undefined:
      countLabel = pluralize(category.count, '', '%d место', '%d места', '%d мест');
      break;
    default:
      countLabel = `${category.count} ${t('seats')}`;
      break;
  }

  return (
    <Styled.Wrapper withoutImages={Boolean(!category.images.length) || Widget.isMobile}>
      <Modal onClickOverlay={hide} width={560}>
        {renderImages(category.images)}
        <Styled.Content>
          <Styled.Title>{transliterate(category.label)}</Styled.Title>
          {category.description && (
            <Styled.Text>
              {category.description === TRANSLATE_DESCRIPTION
                ? i18next.t('categoryDescription')
                : transliterate(category.description)}
            </Styled.Text>
          )}
          {category.count ? (
            <Styled.Footer>
              <Styled.InfoList>
                <Styled.Info>
                  <Styled.InfoLabel>{t('pricePerPiece')}</Styled.InfoLabel>{' '}
                  <Currency>
                    {priceFormatter(category.price)} <CurrencyIcon width={9} height={13} />
                  </Currency>
                </Styled.Info>
                <Styled.Info>
                  <Styled.InfoLabel>{t('available')}</Styled.InfoLabel>
                  {countLabel}
                </Styled.Info>
              </Styled.InfoList>

              <Styled.Controls>
                {`${t('count')}:`}
                <NumericInput
                  min={0}
                  max={category.count}
                  onChange={handleChange}
                  value={value}
                  isMobile
                />
              </Styled.Controls>
            </Styled.Footer>
          ) : (
            <Styled.Footer error>{t('noAvailableSeats')}</Styled.Footer>
          )}
        </Styled.Content>
      </Modal>
    </Styled.Wrapper>
  );
};

// @ts-ignore
export default withTranslation()(CategoryModal);

/* eslint-enable react/no-unused-state */
